import React from 'react';

import './index.css';

const Component = () => {
    return (
        <div className="page-404">
            <div className="container-404">
                <h1 className="icon-404">
                    <i className="fas fa-exclamation-triangle" />
                </h1>
                <h1>404: Page Not Found!</h1>
            </div>
        </div>
    );
};

export default Component;
